import { render, staticRenderFns } from "./SupplyChains.vue?vue&type=template&id=2182a990&scoped=true&"
import script from "./SupplyChains.vue?vue&type=script&lang=js&"
export * from "./SupplyChains.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChains.vue?vue&type=style&index=0&id=2182a990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182a990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
